import { Grid } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';

import { useDetaileQuotation } from './hook';
import { QuotationProps } from './props';

import FieldText from '../../../../../components/general/fields/fieldText';
import { Accordion } from '../../../../../components/general/accordion';
import RichText from '../../../../../components/richText';

export const QuotationDetailGeneralInfo = ({ quotation }: QuotationProps) => {
    const { formik, isDispatch, isPending } = useDetaileQuotation(quotation);

    return (
        <Accordion
            title="INFORMACIÓN GENERAL"
            icon={<FeedIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID:"
                        name="callId"
                        size="small"
                        value={formik.values.callId}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Canal:"
                        name="channel"
                        size="small"
                        value={formik.values.channel}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipo de cotización:"
                        name="typeQuotation"
                        size="small"
                        value={formik.values.typeQuotation}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Ramo:"
                        name="bouquet"
                        size="small"
                        value={formik.values.bouquet}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Estado:"
                        name="status"
                        size="small"
                        value={formik.values.status}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipificación:"
                        name="typification"
                        size="small"
                        value={formik.values.typification}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Etapa:"
                        name="stage"
                        size="small"
                        value={formik.values.stage}
                        disabled
                    />
                </Grid>
                {isDispatch && (
                    <>
                        <Grid item xs={12} sm={6} md={4}>
                            <FieldText
                                label="Número de póliza:"
                                name="policyNumber"
                                size="small"
                                value={formik.values.policyNumber}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FieldText
                                label="Fecha de expedición de póliza:"
                                name="policyDate"
                                size="small"
                                value={formik.values.policyDate}
                                disabled
                            />
                        </Grid>
                    </>
                )}
                {isPending && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Motivo:"
                            name="motive"
                            size="small"
                            value={formik.values.motive}
                            disabled
                        />
                    </Grid>
                )}
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Placa:"
                        name="plate"
                        size="small"
                        value={formik.values.plate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Importe:"
                        name="amount"
                        size="small"
                        value={formik.values.amount}
                        disabled
                    />
                </Grid>
                {formik.values.subtypification && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Subtipificación:"
                            name="subtypification"
                            size="small"
                            value={formik.values.subtypification}
                            disabled
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <FieldText
                        label="Observación"
                        name="observation"
                        size="small"
                        rows={3}
                        value={formik.values.observation}
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <RichText
                        initialContent={formik.values.body}
                        editable={false}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
